import {Action} from '@ngrx/store';

export const GET_STATS = '[Stats] Get Stats';
export const GET_STATS_SUCCESS = '[Stats] Get Stats Success';
export const GET_STATS_ERROR = '[Stats] Get Stats Error';

export class GetStats implements Action {
  readonly type = GET_STATS;

  constructor(public payload: any) {
  }
}

export class GetStatsSuccess implements Action {
  readonly type = GET_STATS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetStatsError implements Action {
  readonly type = GET_STATS_ERROR;

  constructor(public payload: any) {
  }
}

export type StatsActions =
  GetStats
  | GetStatsSuccess
  | GetStatsError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/statistics/store/actions/stats.action.ts